// Note: When updating these change the enum in the types folder as well
export enum DELIVERY_ADDRESS_TYPE {
  HOME = 1,
  WORK = 2,
  FRIENDS_FAMILY = 3,
  OTHER = 4,
}

export enum DELIVERY_ADDRESS_DETAILS_MODE {
  ENTER = 1,
  SAVE = 2,
  EDIT = 3,
}

export enum DELIVERY_INSTRUCTION {
  LEAVE_AT_MY_DOOR = 1,
  HAND_IT_TO_ME = 2,
  CONTACT_ON_ARRIVAL = 3,
}
